module.exports = __webpack_public_path__ + "img/left_arrow_icon.6a6fab60.svg";